import { logger as log } from '@common/logger';
import { PaymentPageService } from '../../../services';
import { vappContainer } from '@/application';

const MODULE_NAME = 'payment.machines.states.checkStatus';

const getSrv = () => {
  return vappContainer.get<PaymentPageService>(PaymentPageService.displayName);
};

export const checkStatus = async (context: any, event: any) => {
  const currentState = 'CHECK_STATUS';
  const method = 'checkStatus';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.checkStatus(event?.payload);
      if (content) {
        return resolve({
          key: 'CHECK_STATUS_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'CHECK_STATUS_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'CHECK_STATUS_FAILED',
        value: _msg,
      });
    }
  });
};
